<template>
  <div id="invite-team-edit-replace" >
    <div class="main" v-if="myOwnTeams.length == 0" >
      <div class="title" >
        <h3>你没有可替换的球队</h3>
      </div>
    </div>
    <div class="main" v-if="myOwnTeams.length > 0" >
      <div class="title" >
        <h3>选择替换的球队</h3>
        <p>选择球队</p>
      </div>
      <van-radio-group v-model="selectedTeam" >
        <van-cell-group class="checkbox">
          <van-cell v-for="(item) in myOwnTeams" :key="item.id" clickable>
            <div class="player" >
              <div>
                <img v-if="item.badge" :src="formatterImgSrc(item.badge)" >
                <img v-else src="@/assets/images/team-logo-empty.png" />
              </div>
              <div>
                <p>{{item.name}}</p>
                <span>{{item.memberCount}}人</span>
              </div>
            </div>
            <van-radio :name="item.id" checked-color="#32A377" />
          </van-cell>
        </van-cell-group>
        <div style="width: 100%; height: 50px;" ></div>
      </van-radio-group>
    </div>
    <div class="foot" v-if="myOwnTeams.length > 0" >
      <van-button type="primary" size="large" @click="confirmAction">确认</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { getBMTeamListByUserId, replaceBMMatchTeam } from '@/api/team'
import { ImageFormat } from '@/utils/'
import filter from 'lodash/filter'
import { RadioGroup, Radio, Toast } from 'vant'

Vue.use(RadioGroup).use(Radio).use(Toast)

export default {
  name: 'Replace',
  data() {
    return {
      myOwnTeams: [],
      selectedTeam: '',
      query: this.$route.query,
      matchId: ''
    }
  },
  created() {
    this.matchId = this.query.matchId
    this.teamId = this.query.teamId
    this.getBMTeamListByUserId()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  methods: {
    getBMTeamListByUserId() {
      let params = {
        pageNum: 1,
        pageSize: 100
      }
      getBMTeamListByUserId(params).then(response => {
        const data = response.data
        this.myOwnTeams = filter(data.teams, function (item) {
          return item.relationTeam >= 80
        })
      })
    },
    confirmAction() {
      const params = {
        matchId: this.matchId,
        teamIdA: this.selectedTeam,
        teamIdB: this.teamId
      }
      replaceBMMatchTeam(params).then(response => {
        const data = response.data
        if (data) {
          Toast('替换球队成功')
          this.$router.push({name: 'InviteTeamInfo', query: {matchId: this.matchId, teamId: this.selectedTeam}})
        }
      })
    }
  }
}
</script>

<style lang="stylus">
#invite-team-edit-replace
  overflow scroll
  .title
    padding: 10px 15px
    h3
      font-size:30px;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin: 0
    p
      font-size:18px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin 0
      padding-top: 10px
  .player
    display flex
    padding 15px
    width 100%
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:last-child
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
  .checkbox
    .van-cell
      padding: 0
      .van-cell__value
        display flex
        justify-content: space-between
        align-items: center
        .van-radio
          padding-right 15px
          align-items: center
  .foot
    position fixed
    bottom 0
    width 100%
    .van-button
      border none
      font-size:16px;
      font-weight normal
      color: #32A377;
      line-height:25px;
    .van-button--primary
      background-color #FAFAFA
      font-size:20px;
      font-weight:400;
</style>



// WEBPACK FOOTER //
// src/pages/invite-team/user/replace.vue